import { OutcomeTypes, sendTypes } from '../enum';

export const getAllOutcomeTypes = () => {
    return [
        { id: OutcomeTypes.LOCAL_ISSUE, name: 'Local Issue' },
        { id: OutcomeTypes.SERVICE_WIDE, name: 'Service Wide' },
        { id: OutcomeTypes.NOTABLE_PRACTICE, name: 'Notable Practice' },
    ];
};

export const getSendTypes = () => {
    return [
        { id: sendTypes.NO, name: 'No' },
        { id: sendTypes.NEED_TO_SEND, name: 'Need to send' },
        { id: sendTypes.SENT, name: 'Sent' },
    ];
};
